module.exports = __webpack_public_path__ + "img/yca-crest.249b4b43.svg";